import { FC, ReactElement } from 'react';
import { Navigate, OutletProps } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import * as Icon from '../icons';

interface LayoutProps {
  Outlet: (props: OutletProps) => ReactElement | null;
}

const Layout: FC<LayoutProps> = ({ Outlet }) => {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>;
  if (user) return <Navigate to='/dashboard/apps' replace />;

  return (
    <>
      <div className='absolute top-52 left-16 w-[calc(100%-4rem)] max-xl:top-84 max-lg:hidden'>
        <Icon.LoginBackground className='h-full w-full' />
      </div>
      <div className='max-lg:bg-white-light flex h-full'>
        <div className='text-green-dark w-[40%] px-8 pt-5 max-lg:hidden'>
          <div className='mb-4 flex justify-end text-sm'>
            par <Icon.Skezi className='mt-[0.2rem] ml-2' />
          </div>
          <div className='text-4xl font-bold'>
            <div>Créer,</div>
            <div className='my-2'>Collaborer,</div>
            <div>Collecter...</div>
          </div>
          <div className='my-4 text-lg'>
            Un espace de connexion <span className='font-bold'>pour toutes nos solutions !</span>
          </div>
          <div className='mt-20 flex'>
            <div className='mr-12'>
              <Icon.Skezia />
              <div className='pt-2 text-sm'>Solution de collecte de données sensibles.</div>
            </div>
            <div>
              {/* <Icon.Skemeet /> */}
              <Icon.Skemeet />
              <div className='pt-2 text-sm'>Solution de télé-expertise.</div>
            </div>
          </div>
        </div>
        <div className='bg-white-light flex min-h-screen w-[60%] flex-col px-10 max-lg:w-full max-lg:pb-5 lg:items-center lg:justify-center xl:px-16'>
          <div className='flex w-full flex-col py-6 lg:hidden'>
            <div className='flex justify-center'>
              <img src='/Skezi.jpg' className='w-36 text-center' />
            </div>
            <div className='my-4 flex justify-center'>
              <span className='w-56 text-center'>Un espace de connexion pour toutes nos solutions.</span>
            </div>
            <div className='flex justify-center'>
              <Icon.SkeziaMobile />
              <span className='relative'>
                <Icon.SkemeetMobile />
              </span>
            </div>
          </div>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Layout;
